import { deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { userAsPromise } from '../providers/userProvider';
import { IApiKey } from '../types';

export const updateKey = async (key: Partial<IApiKey>): Promise<void> => {
  const user = await userAsPromise();
  return updateDoc(doc(user.services.firestore, `/apiKeys/${key.id}`), key);
};

export const deleteKey = async (key: IApiKey): Promise<void> => {
  const user = await userAsPromise();
  return deleteDoc(doc(user.services.firestore, `/apiKeys/${key.id}`));
};

export const createNewKey = async (
  key: Partial<IApiKey>
): Promise<{ apiKey: string; apiUrl: IApiUrl }> => {
  const user = await userAsPromise();
  const fn = httpsCallable(user.services.functions, 'generateApiToken');

  const result = await fn({
    orgId: user.orgId,
    name: key.appName,
    teamIds: key.teamIds || [],
  });
  const apiKey = (result.data as IApiKey).key;
  const apiUrl = lookupApiUrl(user.services.app.name);
  return { apiKey, apiUrl };
};

export interface IApiUrl {
  baseUrl: string;
  tokenPath: string;
  endpoint: string;
}

const lookupApiUrl = (projectName: string): IApiUrl => {
  const apiUrl: IApiUrl = {
    baseUrl: '',
    tokenPath: 'api/token',
    endpoint: 'api/v1',
  };
  switch (projectName) {
    case 'europe':
      apiUrl.baseUrl = 'https://eu.cloud.hawkindynamics.com';
      return apiUrl;
    case 'asia':
      apiUrl.baseUrl = 'https://apac.cloud.hawkindynamics.com';
      return apiUrl;
    case 'dev':
      apiUrl.baseUrl = 'https://cloud.dev.hawkindynamics.com';
      return apiUrl;
    case 'aus':
      apiUrl.baseUrl = 'https://aus.cloud.hawkindynamics.com';
      return apiUrl;
    default:
      apiUrl.baseUrl = 'https://cloud.hawkindynamics.com';
      return apiUrl;
  }
};
